import { AnnouncementsWorkspace } from '@/components/announcements/announcements-workspace'

export function OperationsAnnouncements() {
  return <AnnouncementsWorkspace basePath="/operations/announcements" />
}
